import React from "react";
import "./SplashScreen.css";

const SplashScreen: React.FC = () => (
  <div className="splash-screen">
    <img
      src="../assets/images/logo_animated.gif"
      alt="Loading"
      className="splash-gif"
    />
    <div className="splash-glow"></div>
  </div>
);

export default SplashScreen;
